import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(({ colors, spacingPresets, typographyPresets, breakpoints }) => ({
    artistData: {
        maxWidth: '50%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        maxWidth: '50%',
        flexWrap: 'wrap',
    },
    thumbnail: {
        width: '59px',
        minWidth: '59px',
        height: '59px',
        backgroundSize: 'cover',
        backgroundPositionX: 'center',
    },
    description: {
        marginLeft: '20px',
    },
    title: {
        ...typographyPresets.artistName,
        color: colors.text.light,
        fontSize: '20px',
    },
    tags: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    tag: {
        padding: '4px 8px',
        margin: '0 8px 5px 0',
        borderRadius: '2px',
        backgroundColor: colors.light.darkgrey,
        color: colors.light.grey,
        textTransform: 'uppercase',
        fontSize: '9px',
        fontWeight: 900,
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        whiteSpace: 'nowrap',
    },
    dashboard: {
        padding: spacingPresets.cardPadding,
        color: 'white',
        backgroundColor: colors.dark.dark3,
        maxWidth: '100%',
        [breakpoints.down('md')]: {
            display: 'none',
        },
        [breakpoints.up('md')]: {
            marginTop: '16px',
            marginBottom: '16px',
            borderRadius: '4px',
            display: 'flex',
            justifyContent: 'space-between',
        },
    },
    buttonCointainer: {
        margin: '0 10px 10px 0',
    },
    calendar: {
        fontSize: '14px',
    },
    paper: {
        transform: 'translateX(-50%)',
    },
}))
